module.exports = __webpack_public_path__ + "img/philadelphia.4e6ccfe5.svg";